import Icon from '@/components/ui/AppIcon';
import AppImage from '@/components/ui/AppImage';

export default function Footer() {
  const currentYear = new Date()?.getFullYear();

  const footerLinks = {
    company: [
    { label: 'About Us', href: '/about-us' },
    { label: 'Our Story', href: '/about-us' }],

    properties: [
    { label: 'Services', href: '/amenities-and-services' },
    { label: 'Location', href: '/location-guide' }],

    support: [
    { label: 'Contact Us', href: '/contact-us' },
    { label: 'FAQs', href: '/faq' },
    { label: 'Booking Policy', href: '/booking-policy' },
    { label: 'Privacy Policy', href: '/privacy-policy' }]

  };

  return (
    <footer className="bg-primary text-white">
      <div className="container mx-auto px-4 lg:px-8 py-12">
        <div className="flex flex-col lg:flex-row gap-8 mb-8">
          {/* Brand column */}
          <div className="space-y-4 lg:w-1/3">
            <div>
              <div className="flex items-center space-x-3">
                <div className="relative w-[200px] h-12 flex-shrink-0">
                  <AppImage
                    src="/assets/images/002-1767601217860.png"
                    alt="Proximus Logo"
                    width={200}
                    height={48}
                    className="object-contain w-full h-full" />
                </div>
              </div>
              <p className="text-xs font-medium text-white/90 m-0 p-0 leading-none">
                Boutique Hotel Apartments
              </p>
            </div>
            <p className="text-sm text-white/70">
              Where business meets comfort in Bangalore&apos;s premium corporate corridor
            </p>
            <div className="flex space-x-3">
              <a href="mailto:enquiry@proximusindia.com" className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center transition-colors duration-300">
                <Icon name="EnvelopeIcon" size={20} className="text-white" />
              </a>
              <a href="tel:+917259312233" className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center transition-colors duration-300">
                <Icon name="PhoneIcon" size={20} className="text-white" />
              </a>
              <a href="https://wa.me/917259312233" className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center transition-colors duration-300">
                <Icon name="ChatBubbleLeftRightIcon" size={20} className="text-white" />
              </a>
            </div>
          </div>

          {/* Link columns — always in the same row */}
          <div className="grid grid-cols-3 gap-8 lg:w-2/3">
            <div>
              <h4 className="font-semibold mb-4 text-[rgba(233,233,231,1)]">Company</h4>
              <ul className="space-y-2">
                {footerLinks?.company?.map((link, index) =>
                <li key={index}>
                    <a href={link?.href} className="text-sm text-white/70 hover:text-white transition-colors duration-300">
                      {link?.label}
                    </a>
                  </li>
                )}
              </ul>
            </div>

            <div>
              <h4 className="font-semibold mb-4 text-[rgba(247,247,248,1)]">Properties</h4>
              <ul className="space-y-2">
                {footerLinks?.properties?.map((link, index) =>
                <li key={index}>
                    <a href={link?.href} className="text-sm text-white/70 hover:text-white transition-colors duration-300">
                      {link?.label}
                    </a>
                  </li>
                )}
              </ul>
            </div>

            <div>
              <h4 className="font-semibold mb-4 text-[rgba(252,252,252,1)]">Support</h4>
              <ul className="space-y-2">
                {footerLinks?.support?.map((link, index) =>
                <li key={index}>
                    <a href={link?.href} className="text-sm text-white/70 hover:text-white transition-colors duration-300">
                      {link?.label}
                    </a>
                  </li>
                )}
              </ul>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <div className="text-sm text-white/70">
            © {currentYear} Proximus. All rights reserved.
          </div>
          <div className="flex space-x-6 text-sm text-white/70">
            <a href="/terms-and-conditions" className="hover:text-white transition-colors duration-300">Terms</a>
            <a href="/privacy-policy" className="hover:text-white transition-colors duration-300">Privacy</a>
            <a href="/booking-policy" className="hover:text-white transition-colors duration-300">Booking Policy</a>
          </div>
        </div>
      </div>
    </footer>);

}